import React from "react";
import { View, Text, Button } from "ui";
import { styled, theme } from "styles";
import { Link, NavLink } from "react-router-dom";

export default class Footer extends React.Component {
  public render = () => {
    return (
      <View flexDirection="row" flexWrap="wrap">
        <NavButton
          bg="white"
          as={NavLink}
          to="/faq"
          activeClassName="active"
          color="black"
        >
          <FooterText color="black" fontWeight="bold" fontSize={4} ml={1}>
            Intrebari Frecvente
          </FooterText>
        </NavButton>
        <Text fontSize={4} fontWeight="lighter" alignSelf="center">
          |
        </Text>
        <NavButton
          bg="white"
          as={NavLink}
          to="/tos"
          activeClassName="active"
          color="black"
        >
          <FooterText color="black" fontWeight="bold" fontSize={4} ml={1}>
            Termeni si Conditii
          </FooterText>
        </NavButton>
        <Text fontSize={4} fontWeight="lighter" alignSelf="center">
          |
        </Text>
        <NavButton
          bg="white"
          as={NavLink}
          to="/contact"
          activeClassName="active"
          color="black"
        >
          <FooterText color="black" fontWeight="bold" fontSize={4} ml={1}>
            Contact
          </FooterText>
        </NavButton>
      </View>
    );
  }
}

const FooterText = styled(Text)`
  cursor: pointer;
`;

const NavButton = styled(Button)`
text-decoration: none;

  &.active{
    ${FooterText}{
      color: ${theme.colors.primary};
    }
  }
  &:hover{
    ${FooterText}{
      color: ${theme.colors.primary};
    }
  }
} `;



// WEBPACK FOOTER //
// ./src/components/Footer.tsx